export default {
  data() {
    return {
      demoContent: {
        'html-code': {
          items: [
            {
              value: {
                html_code:
                  '<p>Here is some <strong style="color: red">demo</strong> <strong style="color: blue">HTML</strong>!</p>'
              }
            },
            {
              value: {
                html_code:
                  '<p>You can visit <a href="https://www.w3schools.com/html/" target="_blank">w3schools</a> to learn HTML.</p>'
              }
            }
          ]
        },

        accordion: {
          items: [
            {
              value: {
                heading: 'What is an accordion?',
                content:
                  '<p>The accordion is a graphical control element comprising a vertically stacked list of items, such as labels or thumbnails.</p><p>An accordion is similar in purpose to a tabbed interface, a list of items where exactly one item is expanded into a panel (i.e. list items are shortcuts to access separate panels).</p>'
              }
            },
            {
              value: {
                heading: 'What is an accordion best used for?',
                content:
                  '<p>The accordion is commonly used to present questions and answers. Ever noticed how on other websites, they have a <strong>Frequently Asked Questions</strong> section? We actually have one of these on our main website, we find it helps new/potential customers build trust in the platform before committing.</p>'
              }
            },
            {
              value: {
                heading: 'e.g. What photos will you use on my website?',
                content:
                  '<p>We use photos that you send to us, as well as a range of professional photos from Unsplash (a great, free stock photo website). We have integrated Unsplash into the website admin area, so you can search for photos easily.</p>'
              }
            }
          ]
        },

        'mini-carousel': {
          items: [
            {
              value: {
                heading: '',
                sub_heading: '',
                text: '',
                background_colour: '',
                button_link: '',
                button_text: '',
                image_url: 'https://images.unsplash.com/photo-1453791052107-5c843da62d97?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=80',
                image_alt_text: 'Large tree in middle of forest during daytime '
              }
            },
            {
              value: {
                heading: '',
                sub_heading: '',
                text: '',
                background_colour: '',
                button_link: '',
                button_text: '',
                image_url: 'https://images.unsplash.com/photo-1485871981521-5b1fd3805eee?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=80',
                image_alt_text: 'Landscape photo of New York Empire State Building'
              }
            },
            {
              value: {
                heading: 'Heading',
                sub_heading: '',
                text: 'And some text...',
                background_colour: '',
                button_link: '',
                button_text: '',
                image_url: 'https://images.unsplash.com/photo-1491438590914-bc09fcaaf77a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=80',
                image_alt_text: 'People laughing and talking outside during daytime'
              }
            },
            {
              value: {
                heading: 'Heading',
                sub_heading: 'A Sub heading',
                text: 'And some text...',
                background_colour: '',
                button_link: '',
                button_text: '',
                image_url: 'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=80',
                image_alt_text: 'Brown wooden boat moving towards the mountain '
              }
            },
            {
              value: {
                heading: 'Heading',
                sub_heading: 'Sub Heading',
                text: 'Also with a button',
                background_colour: '',
                button_link: '/',
                button_text: 'Click Me!',
                image_url: 'https://images.unsplash.com/photo-1529905270444-b5e32acc3bdd?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=80',
                image_alt_text: 'Airplane under pink cloudy sky during daytime'
              }
            },
            {
              value: {
                heading: '',
                sub_heading: '',
                text: '',
                background_colour: '',
                button_link: '',
                button_text: '',
                image_url: 'https://images.unsplash.com/photo-1518509562904-e7ef99cdcc86?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=80',
                image_alt_text: 'Large rock formation on blue sea under sky during daytime'
              }
            }
          ]
        },

        slideshow: {
          items: [
            {
              value: {
                heading: 'Heading One',
                sub_heading: 'Heading Two',
                text: 'Some Text',
                background_colour: '',
                button_link: '/',
                button_text: '',
                slide_animation: 'zoom-out',
                slide_height: '66.666vh',
                image_url: 'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
                image_alt_text: 'Brown wooden boat moving towards the mountain '
              }
            },
            {
              value: {
                heading: 'With a heading',
                sub_heading: 'and Sub Heading',
                text: '',
                background_colour: '',
                button_link: '/',
                button_text: 'Click Me!',
                slide_height: '100vh',
                image_url: 'https://images.unsplash.com/photo-1491438590914-bc09fcaaf77a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
                image_alt_text: 'People laughing and talking outside during daytime'
              }
            },
            {
              value: {
                heading: 'Multiple Heights',
                sub_heading: '',
                text: '',
                background_colour: '',
                button_link: '/',
                slide_animation: 'pan-right',
                button_text: 'Click Me!',
                slide_height: '50vh',
                image_url: 'https://images.unsplash.com/photo-1485871981521-5b1fd3805eee?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
                image_alt_text: 'Landscape photo of New York Empire State Building'
              }
            },
            {
              value: {
                heading: '',
                sub_heading: '',
                text: '',
                background_colour: '',
                button_link: '',
                button_text: '',
                slide_height: '50vh',
                image_url: 'https://images.unsplash.com/photo-1518509562904-e7ef99cdcc86?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
                image_alt_text: 'Large rock formation on blue sea under sky during daytime'
              }
            },
            {
              value: {
                heading: 'With a heading',
                sub_heading: 'and Sub Heading',
                text: '',
                background_colour: '',
                button_link: '',
                button_text: '',
                slide_height: '33.333vh',
                image_url: 'https://images.unsplash.com/photo-1453791052107-5c843da62d97?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
                image_alt_text: 'Large tree in middle of forest during daytime '
              }
            },
            {
              value: {
                heading: '',
                sub_heading: 'Smaller Banner',
                text: '',
                background_colour: '',
                button_link: '/',
                button_text: '',
                slide_height: '25vh',
                image_url: 'https://images.unsplash.com/photo-1529905270444-b5e32acc3bdd?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
                image_alt_text: 'Airplane under pink cloudy sky during daytime'
              }
            },
            {
              value: {
                heading: '',
                sub_heading: '',
                text: '',
                background_colour: '',
                button_link: '/',
                button_text: 'Click Me!',
                slide_height: '25vh',
                image_url: 'https://images.unsplash.com/photo-1491438590914-bc09fcaaf77a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
                image_alt_text: 'People laughing and talking outside during daytime'
              }
            }
          ]
        },

        'pricing-table': {
          items: [
            {
              value: {
                column_title: 'Bronze',
                currency_symbol: '£',
                price: '20',
                time_period: '/month',
                colour: '#cd7f32',
                button_link: 'http://stripe.com',
                button_text: 'Buy Now',
                feature_1: 'Change the colour',
                feature_2: 'Set the currency',
                feature_3: 'Set the time period'
              }
            },
            {
              value: {
                column_title: 'Silver',
                currency_symbol: '£',
                price: '100',
                time_period: 'month',
                colour: '#D3D3D3',
                button_link: 'http://stripe.com',
                button_text: 'buy now',
                feature_1: 'Change the colour',
                feature_2: 'Set the currency',
                feature_3: 'Set the time period',
                feature_4: 'List many features!'
              }
            },
            {
              value: {
                column_title: 'Gold',
                currency_symbol: '£',
                price: '100',
                time_period: 'month',
                colour: '#FFDF00',
                button_link: 'http://stripe.com',
                button_text: 'buy now',
                feature_1: 'Change the colour',
                feature_2: 'Set the currency',
                feature_3: 'Set the time period'
              }
            }
          ]
        },

        'text-content': {
          items: [
            {
              value: {
                text:
                  '<h2>Heading</h2><p>This has a single column and the <strong>boxed</strong> setting is switched on. Looks pretty nice, right?</p>',
                columns: 1,
                boxed: true
              }
            },
            {
              value: {
                text:
                  '<p>This text is also boxed and has two columns. Here is some additional information to fill up the area, so you can see the columns in action! Here is some additional information to fill up the area, so you can see the columns in action! Here is some additional information to fill up the area, so you can see the columns in action! Here is some additional information to fill up the area, so you can see the columns in action!</p>',
                columns: 2,
                boxed: true,
                column_borders: true
              }
            },
            {
              value: {
                text:
                  "<p>This text is boxed and has three columns. It'll be worth noting that on smaller devices like mobiles and tablets, it will default to a single column. We wouldn't want it crammed!</p> <p>This text is boxed and has three columns. It'll be worth noting that on smaller devices like mobiles and tablets, it will default to a single column. We wouldn't want it crammed!</p> <p>This text is boxed and has three columns. It'll be worth noting that on smaller devices like mobiles and tablets, it will default to a single column. We wouldn't want it crammed!</p> <p>This text is boxed and has three columns. It'll be worth noting that on smaller devices like mobiles and tablets, it will default to a single column. We wouldn't want it crammed! It'll be worth noting that on smaller devices like mobiles and tablets, it will default to a single column. We wouldn't want it crammed! It'll be worth noting that on smaller devices like mobiles and tablets, it will default to a single column. We wouldn't want it crammed!</p>",
                columns: 3,
                boxed: true,
                column_borders: true
              }
            },
            {
              value: {
                text:
                  '<p>Not much to see here, just some text without a background. Nice and simple. Here is some more text to fill up the area and give you a better idea of what it might look like on your website. Here is some more text to fill up the area and give you a better idea of what it might look like on your website. Here is some more text to fill up the area and give you a better idea of what it might look like on your website.</p><p>Oh, you can of course have multiple paragraphs within the text content widget.</p>',
                columns: 1
              }
            },
            {
              value: {
                text:
                  '<p>This is the same as above, but without the <strong>boxed</strong> setting and is split into two columns. Here is some additional information to fill up the area, so you can see the columns in action! Here is some additional information to fill up the area, so you can see the columns in action!</p>',
                columns: 2
              }
            },
            {
              value: {
                text:
                  "<p>You can actually have up to four columns within a text content block. May come in useful if you've got a lot to say! Here is some additional information to fill up the area, so you can see the columns in action! Here is some additional information to fill up the area, so you can see the columns in action! Here is some additional information to fill up the area, so you can see the columns in action!</p>",
                columns: 4,
                boxed: true,
                column_borders: true
              }
            }
          ]
        },

        'product-list': {
          items: [
            {
              value: {
                product_title: 'Nike Shoes - Shoes',
                product_currency: '£',
                product_price: '50',
                product_compare_price: '75',
                product_category: 'Shoes',
                product_description:
                  '<p>Here is the product description.</p><p>A product description is the marketing copy that explains what a product is and why it’s worth purchasing. The purpose of a product description is to supply customers with important information about the features and benefits of the product so they’re compelled to buy.</p>',
                text_position: 'text-right',
                text_width: 'three-quarters',
                text_alignment: 'align-middle',
                boxed: true,
                bottom_spacing: true,
                image_url: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80',
                image_alt_text: 'Nike shoes'
              }
            },
            {
              value: {
                product_title: 'Fossil Watch - Watches',
                product_currency: '£',
                product_price: '250',
                product_compare_price: '300',
                product_category: 'Watches',
                product_description:
                  '<p>Here is the product description.</p><p>A product description is the marketing copy that explains what a product is and why it’s worth purchasing. The purpose of a product description is to supply customers with important information about the features and benefits of the product so they’re compelled to buy.</p>',
                text_position: 'text-right',
                text_width: 'three-quarters',
                text_alignment: 'align-middle',
                boxed: true,
                bottom_spacing: true,
                image_url: 'https://images.unsplash.com/photo-1542496658-e33a6d0d50f6?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80',
                image_alt_text: 'Fossil Watch'
              }
            },
            {
              value: {
                product_title: 'Hand Bag - Bags',
                product_currency: '£',
                product_price: '450',
                product_compare_price: '550',
                product_category: 'Bags',
                product_description:
                  '<p>Here is the product description.</p><p>A product description is the marketing copy that explains what a product is and why it’s worth purchasing. The purpose of a product description is to supply customers with important information about the features and benefits of the product so they’re compelled to buy.</p>',
                text_position: 'text-right',
                text_width: 'three-quarters',
                text_alignment: 'align-middle',
                boxed: true,
                bottom_spacing: true,
                image_url: 'https://images.unsplash.com/photo-1548036328-c9fa89d128fa?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80',
                image_alt_text: 'Hand Bag'
              }
            }
          ]
        },

        'text-image': {
          items: [
            {
              value: {
                text:
                  '<h2>With A Background</h2><p>Some demo content here. Some demo content here. Some demo content here.</p>',
                text_position: 'text-right',
                text_width: 'three-quarters',
                text_alignment: 'align-middle',
                boxed: true,
                bottom_spacing: true,
                image_url: 'https://images.unsplash.com/photo-1518509562904-e7ef99cdcc86?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=80',
                image_alt_text: 'Large rock formation on blue sea under sky during daytime'
              }
            },
            {
              value: {
                text:
                  '<h2>Without A Background</h2><p>Some demo content here. Some demo content here. Some demo content here.</p>',
                text_position: 'text-right',
                text_width: 'three-quarters',
                text_alignment: 'align-middle',
                boxed: false,
                bottom_spacing: true,
                image_url: 'https://images.unsplash.com/photo-1453791052107-5c843da62d97?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=80',
                image_alt_text: 'Large tree in middle of forest during daytime'
              }
            },
            {
              value: {
                text:
                  '<p>Half width, text on the left and <strong>no bottom spacing</strong>.</p>',
                text_position: 'text-left',
                text_width: 'half',
                text_alignment: 'align-middle',
                boxed: true,
                bottom_spacing: false,
                image_url: 'https://images.unsplash.com/photo-1485871981521-5b1fd3805eee?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=80',
                image_alt_text: 'Landscape photo of New York Empire State Building'
              }
            },
            {
              value: {
                text:
                  '<h2>A Number of options</h2><p>Enough flexibility to create various layouts for your content.</p>',
                text_position: 'text-right',
                text_width: 'half',
                text_alignment: 'align-middle',
                boxed: true,
                bottom_spacing: true,
                image_url: 'https://images.unsplash.com/photo-1529905270444-b5e32acc3bdd?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=80',
                image_alt_text: 'Airplane under pink cloudy sky during daytime'
              }
            },
            {
              value: {
                text:
                  '<p>Align your text to the top, middle or <strong>bottom</strong>.</p>',
                text_position: 'text-left',
                text_width: 'one-third',
                text_alignment: 'align-bottom',
                boxed: true,
                bottom_spacing: true,
                image_url: 'https://images.unsplash.com/photo-1491438590914-bc09fcaaf77a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=80',
                image_alt_text: 'People laughing and talking outside during daytime'
              }
            }
          ]
        },

        tabs: {
          items: [
            {
              value: {
                tab_heading: 'Tab 1',
                content:
                  '<h2>Heading for first tab</h2><p>Here is some information. The tabs will animate to the height of the content inside of it. Try <strong>Tab 2</strong> to see it in action. Here is some information. The tabs will animate to the height of the content inside of it. Try <strong>Tab 2</strong> to see it in action. Here is some information. The tabs will animate to the height of the content inside of it. Try <strong>Tab 2</strong> to see it in action. Here is some information. The tabs will animate to the height of the content inside of it. Try <strong>Tab 2</strong> to see it in action. Here is some information. The tabs will animate to the height of the content inside of it. Try <strong>Tab 2</strong> to see it in action.</p><p>Here is some information. The tabs will animate to the height of the content inside of it. Try <strong>Tab 2</strong> to see it in action. Here is some information. The tabs will animate to the height of the content inside of it. Try <strong>Tab 2</strong> to see it in action. Here is some information. The tabs will animate to the height of the content inside of it. Try <strong>Tab 2</strong> to see it in action. Here is some information. The tabs will animate to the height of the content inside of it. Try <strong>Tab 2</strong> to see it in action. Here is some information. The tabs will animate to the height of the content inside of it. Try <strong>Tab 2</strong> to see it in action.</p>'
              }
            },
            {
              value: {
                tab_heading: 'Tab 2',
                content:
                  '<h2>Heading for third tab</h2><p>Here is some information. The tabs will animate to the height of the content inside of it. Try <strong>Tab 1</strong> for an example</p>'
              }
            },
            {
              value: {
                tab_heading: 'Tab 3',
                content:
                  '<h2>Heading for third tab</h2><p>Here is some information. The tabs will animate to the height of the content inside of it. Try <strong>Tab 1</strong> for an example</p>'
              }
            }
          ]
        },

        'basic-gallery': {
          items: [
            {
              value: {
                type: 'gallery-image',
                image_url: 'https://images.unsplash.com/photo-1518509562904-e7ef99cdcc86?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
                image_alt_text: 'Large rock formation on blue sea under sky during daytime'
              }
            },
            {
              value: {
                type: 'gallery-image',
                image_url: 'https://images.unsplash.com/photo-1453791052107-5c843da62d97?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
                image_alt_text: 'Large tree in middle of forest during daytime '
              }
            },
            {
              value: {
                type: 'gallery-image',
                image_url: 'https://images.unsplash.com/photo-1485871981521-5b1fd3805eee?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
                image_alt_text: 'Landscape photo of New York Empire State Building'
              }
            },
            {
              value: {
                type: 'gallery-image',
                image_url: 'https://images.unsplash.com/photo-1529905270444-b5e32acc3bdd?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
                image_alt_text: 'Airplane under pink cloudy sky during daytime'
              }
            },
            {
              value: {
                type: 'gallery-image',
                image_url: 'https://images.unsplash.com/photo-1491438590914-bc09fcaaf77a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
                image_alt_text: 'People laughing and talking outside during daytime'
              }
            },
            {
              value: {
                type: 'gallery-image',
                image_url: 'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
                image_alt_text: 'Brown wooden boat moving towards the mountain '
              }
            },
            {
              value: {
                type: 'gallery-image',
                image_url: 'https://images.unsplash.com/photo-1558980664-1db506751c6c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
                image_alt_text: 'Black motorcycle parked near grey concrete pillar'
              }
            },
            {
              value: {
                type: 'gallery-image',
                image_url: 'https://images.unsplash.com/photo-1605125643586-54150f6619fc?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1258&q=80',
                image_alt_text: 'Concrete pathway between autumn trees'
              }
            }
          ]
        },

        'image-grid': {
          items: [
            {
              value: {
                heading: 'Heading 1',
                text:
                  'This is the text that appears when hovering over block section 1',
                link: '/contact',
                link_text: 'Contact us',
                image_url: 'https://images.unsplash.com/photo-1518509562904-e7ef99cdcc86?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
                image_alt_text: 'Large rock formation on blue sea under sky during daytime'
              }
            },
            {
              value: {
                heading: 'Heading 2',
                text:
                  '<p>This is the text that appears when hovering over block section 2</p>',
                link: '/contact',
                link_text: 'Contact us',
                image_url: 'https://images.unsplash.com/photo-1453791052107-5c843da62d97?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
                image_alt_text: 'Large tree in middle of forest during daytime '
              }
            },
            {
              value: {
                heading: 'Heading 3',
                text:
                  '<p>This is the text that appears when hovering over block section 3</p>',
                link: '/contact',
                link_text: 'Contact us',
                image_url: 'https://images.unsplash.com/photo-1485871981521-5b1fd3805eee?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
                image_alt_text: 'Landscape photo of New York Empire State Building'
              }
            },
            {
              value: {
                heading: 'Heading 4',
                text:
                  '<p>This is the text that appears when hovering over block section 4</p>',
                link: '/contact',
                link_text: 'Contact us',
                image_url: 'https://images.unsplash.com/photo-1529905270444-b5e32acc3bdd?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
                image_alt_text: 'Airplane under pink cloudy sky during daytime'
              }
            },
            {
              value: {
                heading: 'Heading 5',
                text:
                  '<p>This is the text that appears when hovering over block section 5</p>',
                link: '/contact',
                link_text: 'Contact us',
                image_url: 'https://images.unsplash.com/photo-1491438590914-bc09fcaaf77a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
                image_alt_text: 'People laughing and talking outside during daytime'
              }
            },
            {
              value: {
                heading: 'Heading 6',
                text:
                  '<p>This is the text that appears when hovering over block section 6</p>',
                link: '/contact',
                link_text: 'Contact us',
                image_url: 'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
                image_alt_text: 'Brown wooden boat moving towards the mountain '
              }
            },
            {
              value: {
                heading: 'Heading 7',
                text:
                  '<p>This is the text that appears when hovering over block section 7</p>',
                link: '/contact',
                link_text: 'Contact us',
                image_url: 'https://images.unsplash.com/photo-1516156008625-3a9d6067fab5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
                image_alt_text: 'Aerial photography of rural'
              }
            },
            {
              value: {
                heading: 'Heading 8',
                text:
                  '<p>This is the text that appears when hovering over block section 8</p>',
                link: '/contact',
                link_text: 'Contact us',
                image_url: 'https://images.unsplash.com/photo-1558980664-1db506751c6c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
                image_alt_text: 'Black motorcycle parked near grey concrete pillar'
              }
            }
          ]
        },

        'feature-blocks': {
          items: [
            {
              value: {
                heading: 'Heading 1',
                text:
                  '<p>Here is some content for section 1. Here is some content for section 1. <p>Here is some content for section 1.</p>',
                link: '/contact',
                link_text: 'Contact us',
                image_url: 'https://images.unsplash.com/photo-1518509562904-e7ef99cdcc86?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
                image_alt_text: 'Large rock formation on blue sea under sky during daytime'
              }
            },
            {
              value: {
                heading: 'Heading 2',
                text:
                  '<p>Here is some content for section 2. Here is some content for section 2. Here is some content for section 2.</p>',
                link: '/contact',
                link_text: 'Contact us',
                image_url: 'https://images.unsplash.com/photo-1453791052107-5c843da62d97?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
                image_alt_text: 'Large tree in middle of forest during daytime '
              }
            },
            {
              value: {
                heading: 'Heading 3',
                text:
                  '<p>Here is some content for section 3. Here is some content for section 3. Here is some content for section 3.</p>',
                link: '/contact',
                link_text: 'Contact us',
                image_url: 'https://images.unsplash.com/photo-1485871981521-5b1fd3805eee?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
                image_alt_text: 'Landscape photo of New York Empire State Building'
              }
            },
            {
              value: {
                heading: 'Heading 4',
                text:
                  '<p>Here is some content for section 4. Here is some content for section 4. Here is some content for section 4.</p>',
                link: '/contact',
                link_text: 'Contact us',
                image_url: 'https://images.unsplash.com/photo-1529905270444-b5e32acc3bdd?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
                image_alt_text: 'Airplane under pink cloudy sky during daytime'
              }
            },
            {
              value: {
                heading: 'Heading 5',
                text:
                  '<p>Here is some content for section 5. Here is some content for section 5. Here is some content for section 5.</p>',
                link: '/contact',
                link_text: 'Contact us',
                image_url: 'https://images.unsplash.com/photo-1491438590914-bc09fcaaf77a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
                image_alt_text: 'People laughing and talking outside during daytime'
              }
            },
            {
              value: {
                heading: 'Heading 6',
                text:
                  '<p>Here is some content for section 6. Here is some content for section 6. Here is some content for section 6.</p>',
                link: '/contact',
                link_text: 'Contact us',
                image_url: 'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
                image_alt_text: 'Brown wooden boat moving towards the mountain '
              }
            },
            {
              value: {
                heading: 'Heading 7',
                text:
                  '<p>Here is some content for section 7. Here is some content for section 7. Here is some content for section 7.</p>',
                link: '/contact',
                link_text: 'Contact us',
                image_url: 'https://images.unsplash.com/photo-1516156008625-3a9d6067fab5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
                image_alt_text: 'Aerial photography of rural'
              }
            },
            {
              value: {
                heading: 'Heading 8',
                text:
                  '<p>Here is some content for section 8. Here is some content for section 8. Here is some content for section 8.</p>',
                link: '/contact',
                link_text: 'Contact us',
                image_url: 'https://images.unsplash.com/photo-1558980664-1db506751c6c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
                image_alt_text: 'Black motorcycle parked near grey concrete pillar'
              }
            }
          ]
        },

        'image-cards': {
          items: [
            {
              value: {
                heading: 'Heading 1',
                text:
                  '<p>Here is some text for your image card. Here is some text for your image card.</p>',
                link: '/',
                link_text: 'Contact Us',
                image_url: 'https://images.unsplash.com/photo-1518509562904-e7ef99cdcc86?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=80',
                image_alt_text: 'Large rock formation on blue sea under sky during daytime'
              }
            },
            {
              value: {
                heading: 'Heading 2',
                text:
                  '<p>Here is some text for your image card. Here is some text for your image card. It also has a button.</p>',
                link: '/contact',
                link_text: 'Contact us',
                image_url: 'https://images.unsplash.com/photo-1453791052107-5c843da62d97?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=80',
                image_alt_text: 'Large tree in middle of forest during daytime'
              }
            },
            {
              value: {
                heading: 'Heading 3',
                text:
                  '<p>Here is some text for your image card. Here is some text for your image card.</p>',
                link: '/contact',
                link_text: 'Contact us',
                image_url: 'https://images.unsplash.com/photo-1485871981521-5b1fd3805eee?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=80',
                image_alt_text: 'Landscape photo of New York Empire State Building'
              }
            }
          ]
        },

        'simple-form': {
          items: [
            {
              value: {
                label: 'Your Message',
                field_type: 'form-textarea',
                placeholder: ''
              }
            },
            {
              value: {
                label: 'How did you hear about us?',
                field_type: 'form-select',
                dropdown_options:
                  'Search Engine, Facebook, Instagram, Radio, TV, Word of mouth, Other'
              }
            },
            {
              value: {
                label: 'Accept the terms?',
                field_type: 'form-checkbox'
              }
            }
          ]
        },

        'landing-form': {
          items: [
            {
              value: {
                image_url: 'https://images.unsplash.com/photo-1506501139174-099022df5260?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1800&q=80',
                image_alt_text: 'London City banner',
                image_animation: 'pan-down',
                heading: 'Top plumber in London',
                sub_heading: '24 hour callout',
                content: `<p>Grab attention by showing your customer what you're offering. You can copy/paste emojis to make it more visually appealing!</p><ul><li><p><strong>Feature One</strong></p></li><li><p><strong>Feature Two</strong></p></li><li><p><strong>Feature Three</strong></p></li></ul><p>You can choose the width of this text and whether you'd like to to display <strong>above</strong> or <strong>below</strong> the contact form on mobile devices. You can also choose the style of the page by changing the <strong>Landing Form Style</strong> option.</p>`,
                landing_form_style: 'landing-form-one',
                text_position_desktop: 'text-left',
                text_width_desktop: 'three-fifths',
                text_position_mobile: 'text-above',
                display_phone_field: 'true',
                custom_field_label_1: 'Interested In',
                custom_field_type_1: 'form-select-1',
                custom_field_options_1: 'Service 1, Service 2, Service 3, etc.',
                custom_field_label_2: 'How did you hear about us?',
                custom_field_type_2: 'form-select-2',
                custom_field_options_2: 'Google advert, Facebook advert, Search engine, Word of mouth, Other',
                custom_field_text_placeholder_2: '',
                custom_field_text_box_placeholder_2: '',
                custom_field_label_3: 'Your Message',
                custom_field_type_3: 'form-textarea-3',
                custom_field_text_box_placeholder_3: 'Please include as much detail as possible.',
                custom_field_options_3: '',
                custom_field_label_4: '',
                custom_field_type_4: 'form-select-4',
                custom_field_options_4: ''
              }
            }
          ]
        },

        'team-members': {
          items: [
            {
              value: {
                name: 'George Mann',
                job_role: 'Developer',
                bio:
                  '<p>In any industry where the people behind a company are as important as the company itself, you’re likely to find a kind of expanded “about” page that includes information on individual employees. These pages are a valuable addition to any site where human contact is an important part of the industry. It adds a personal touch to the company and can lend trust to visitors.</p>',
                facebook_username: 'newwebsiteuk',
                instagram_username: 'new_website.co.uk',
                image_url: 'https://images.unsplash.com/photo-1538384690625-e2e7bcf9e402?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=934&q=80',
                image_alt_text: 'Man with glasses holding bag during daytime'
              }
            },
            {
              value: {
                name: 'Charlotte Wren',
                job_role: 'Project Manager',
                bio:
                  '<p>In any industry where the people behind a company are as important as the company itself, you’re likely to find a kind of expanded “about” page that includes information on individual employees. These pages are a valuable addition to any site where human contact is an important part of the industry. It adds a personal touch to the company and can lend trust to visitors.</p>',
                youtube_username: 'youtube-user',
                twitter_username: 'twitter-user',
                instagram_username: 'new_website.co.uk',
                image_url: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=934&q=80',
                image_alt_text: 'Closeup photography of woman'
              }
            },
            {
              value: {
                name: 'John Parks',
                job_role: 'Accountant',
                phone_number: '01234 567890',
                email_address: 'john@accountant.com',
                image_url: 'https://images.unsplash.com/photo-1559548331-f9cb98001426?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=900&q=80',
                image_alt_text: 'Man wearing black suit jacket '
              }
            }
          ]
        },

        'shop-collection': {
          items: [
            {
              value: {
                collection_slug: 'frontpage'
              }
            }
          ]
        },

        reviews: {
          items: [
            {
              value: {
                author: 'Martin E',
                review:
                  '<p>Extremely satisfied with the service Jack has provided. After finding his details on Facebook. He accommodated to my many requests and the turnaround was very quick. Would highly recommend!</p>'
              }
            },
            {
              value: {
                author: 'Ismael J',
                review: `<p>We came across Jack on social media and I have to say he is a very professional and reliable individual.</p><p>We had a website and logo created from Jack and one of the main things is that you can always get hold of him and he is always very helpful.</p><p>Compared to other individuals who are in the same profession that we have used before he is by far more professional and very good at his work! Would highly recommend! Thanks Jack</p>`
              }
            },
            {
              value: {
                author: 'Jim B',
                review:
                  '<p>Jack is excellent. I approached him to help me design a new logo and website for my business and all throughout the process he was engaging, responsive, helpful and all at a highly reasonable price.</p><p>The logo and website he created for me were of an extremely high professional standard. I would commend Jack to anyone who needs any of the professional services he offers. 10/10, will use again... and again... and again!</p>'
              }
            },
            {
              value: {
                author: 'Adam G',
                review: `<p>I cant recommend Jack enough! He has really helped to take my online buisness to another level in terms of design and functionality of my website.</p><p>Always full of great new ideas and very responsive which is always great when running a buisness! I'd say to anyone looking for a high quality website look no further you definitely will not be disappointed, Best decision we ever made!</p><p>Thanks for all your hardwork Jack!</p>`
              }
            },
            {
              value: {
                author: 'Sam C',
                review: `<p>I’m really happy to leave this review for Jack. After a few weeks of looking around to find someone to design me a website, I was speaking to Jack and a few other designers.</p><p>What made Jack really standout from the rest was his eagerness to build me a great looking website and how friendly he was. I’m so happy I went with Jack. His aftercare has been second to none.</p><p>I’m getting some SEO to get my website on Google page number 1 and even the SEO agency has heaped praise upon Jack. Thank you Jack you're a star.</p>`
              }
            }
          ]
        },

        'youtube-videos': {
          items: [
            {
              value: {
                video_url: 'https://www.youtube.com/watch?v=GJOAlNAnR_c',
                boxed: true
              }
            },
            {
              value: {
                video_url: 'https://www.youtube.com/watch?v=Qt4h6s9w54A',
                boxed: true
              }
            },
            {
              value: {
                video_url: 'https://www.youtube.com/watch?v=GJOAlNAnR_c',
                boxed: true
              }
            },
            {
              value: {
                video_url: 'https://www.youtube.com/watch?v=GJOAlNAnR_c',
                boxed: true
              }
            },
            {
              value: {
                video_url: 'https://www.youtube.com/watch?v=Qt4h6s9w54A',
                boxed: true
              }
            }
          ]
        },

        alert: {
          items: [
            {
              value: {
                content: 'This is a general alert element',
                type: 'general'
              }
            },
            {
              value: {
                content: 'This is an error alert element',
                type: 'error'
              }
            },
            {
              value: {
                content: 'This is a success alert element',
                type: 'success'
              }
            },
            {
              value: {
                content: 'This is a notice alert element',
                type: 'notice'
              }
            }
          ]
        },

        'section-separator': {
          items: [
            {
              value: {
                style: 'slant',
                flip_vertical: false,
                flip_horizontal: false
              }
            }
          ]
        }
      }
    }
  }
}
